export default __webpack_public_path__ + "assets/fonts/ded10eca1547cb07ed7f11b90c1c8b0d.woff";